import axios from 'axios'
export { getApiBaseHint, getApiBaseUrl } from '@/config/appConfig'
import { getApiBaseUrl } from '@/config/appConfig'

const api = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true
})

export function setupApiInterceptors ({ store, router }) {
  api.interceptors.response.use(undefined, function (error) {
    const originalRequest = error?.config

    if (
      error?.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.skipAuthRedirect
    ) {
      originalRequest._retry = true
      store.dispatch('logOut')
      const currentRoute = router.currentRoute?.value
      const currentPath = currentRoute?.fullPath
      const redirect = currentPath && currentPath !== '/login'
        ? currentPath
        : originalRequest.headers?.Referer || ''
      if (redirect && typeof window !== 'undefined') {
        window.sessionStorage.setItem('authRedirectAfterLogin', redirect)
      }
      return router.push({
        path: currentRoute?.meta?.shoppingLayout ? '/shopping/login' : '/login',
        query: redirect ? { redirect } : {}
      })
    }

    return Promise.reject(error)
  })
}

export default api
